﻿// Formats a screener number according to its unit.
export function fmtMetric(v, unit) {
  if (v === null || v === undefined) return "—";
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  if (unit === "flag") return n ? "Yes" : "No";
  if (unit === "days") return String(Math.round(n));
  if (unit === "$M") return Math.round(n).toLocaleString("en-US");
  if (unit === "") return Math.abs(n) >= 1000 ? Math.round(n).toLocaleString("en-US") : String(Number(n.toFixed(2)));
  return n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export const unitSuffix = (unit) => (["$", "$B", "$M", "%", "x"].includes(unit) ? ` (${unit})` : unit === "days" ? " (days)" : "");
